import React from 'react';
import { theme } from '../../styles/theme';
import { useIsMobile } from '../../hooks/useIsMobile';

export function CenteredLayout({ children }: { children: React.ReactNode }) {
  const mobile = useIsMobile();

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      minHeight: mobile ? 'calc(100vh - 56px)' : 'calc(100vh - 80px)',
      padding: mobile ? `${theme.spacing.lg} ${theme.spacing.md}` : `${theme.spacing['3xl']} ${theme.spacing['3xl']}`,
    }}>
      <div style={{ width: '100%', maxWidth: '1400px', display: 'flex', justifyContent: 'center' }}>
        {children}
      </div>
    </div>
  );
}
